module.exports = __webpack_public_path__ + "static/media/map_station_icon_mini.07e33074.svg";